import { render, staticRenderFns } from "./PartyAreas.vue?vue&type=template&id=0f20b10a&scoped=true&"
import script from "./PartyAreas.vue?vue&type=script&lang=js&"
export * from "./PartyAreas.vue?vue&type=script&lang=js&"
import style0 from "./PartyAreas.vue?vue&type=style&index=0&id=0f20b10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f20b10a",
  null
  
)

export default component.exports